import { CHANGE_LANG } from 'actions/appAction';

import update from 'immutability-helper';

const language = (state = {}, action) => {
    let mergeState;
    switch (action.type) {
        case CHANGE_LANG:
            mergeState = update(state, {
                lang: { $set: action.lang },
            });
            break;
        default:
            return state;
    }
    return mergeState;
};
export default language;
